import gsap from 'gsap';
import { BrushHair } from './BrushHair';
import { hexToHsl, getColorDifference } from './utils';
import { BrushOptions } from "./BrushOptions";

const SPEED = 140; // diviseur (the lower, the slower)
const MIN_ANIM_DURATION = 4; //seconds
const HAIRS_COUNT = 14;
const TWO_PI = Math.PI * 2;
const ANGLE_RAD_180 = Math.PI;

const PATHS = shuffle([
    "M35.436,48.182c0,0,31.758-37.202,51.72-18.147 s33.573,35.387,19.962,48.09s-50.724-33.56,5.489-48.538s133.338,78.481,65.286,102.072s-64.423-73.497,3.629-92.551 s84.385,26.314,84.385,26.314 ",
    "M26.501,33.999c-2.722,37.202-11.796,74.404,26.314,71.682 s11.796-72.589,65.33-82.57s25.406,77.126,52.627,99.81s125.355,37.431,103.963-100.603 ",
    "M25.225,26.392c24.499,1.815,41.739,23.592,34.48,58.979 c-7.259,35.387,20.869,55.349,45.368,29.036s37.678-36.002,68.744-24.806s78.535-56.628,33.931-57.65 c-44.604-1.022-50.956,99.696,1.672,101.511s63.527-26.928,66.697-43.861 ",
    "M23.348,128.328c45.565,8.044,90.026,15.303,114.525-38.231 s127.031-102.532,89.829-19.962s-66.238-42.646-104.347-23.592s-29.943,91.846,30.397,77.227s40.622-70.821,99.479-46.349 c0,0,28.751,11.025,24.295,39.979 ",
    "M24.807,116.472c11.796-7.259,10.888-46.276,48.998-56.257 s19.633,60.305,62.897,72.799s1.453-95.254,48.219-109.886s74.167,8.134,70.901,48.017s12.027,71.261,20.713,70.09 ",
    "M279.273,46.443c-28.588-7.592-50.365-13.944-85.752,7.833 s-17.24,73.497-74.404,52.627S90.989,30.685,50.158,46.11s-25.115,74.486-25.115,74.486 ",
    "M24.094,19.636c23.592-0.907,80.756-12.703,65.33,20.869 s12.703,37.202,27.221,26.314c14.518-10.888,22.971-41.712,50.048-22.217s38.885,11.356,46.592,0 c7.707-11.356,22.224-31.318,35.835-17.707s26.314,59.886-28.128,77.126s-94.366,2.722-67.145-10.888s25.406,53.535,51.72,42.646 s35.387-33.573,51.72-25.406s19.962,32.665,19.962,32.665 ",
    "M21.795,42.571c0,0,8.166-14.518,14.518-2.722 s6.352,46.276,17.24,33.573s28.128-39.017,30.85-21.777c2.722,17.24,13.61,37.202,40.831,15.425s59.886-27.221,48.998-1.815 s-47.183,58.071-19.055,54.442c28.128-3.629,87.107-21.777,72.589-52.627s-49.745-42.811-72.509-31.84S37.22,84.31,79.866,116.975 s92.939-37.98,115.235-35.387c39.017,4.537-14.518,59.886,39.924,57.164c53.843-2.692,33.573-62.608,29.036-78.941 s15.486-38.726,15.486-38.726 ",
    "M23.357,132.261c33.573,3.629,62.03,21.971,80.92,3.727 s-0.164-38.207-21.034-40.929s-32.665-46.276,5.444-56.257s52.45,13.091,48.002,38.303c-4.448,25.212-15.336,58.785,7.348,54.248 c22.684-4.537,63.839-41.11,42.646-65.33c-12.703-14.518-9.981-24.499-4.537-36.295c9.529-20.646,65.33-19.962,50.812,15.425 s-51.497,95.048,45.026,98.79 ",
    "M23.357,19.784c0,0,88.922-11.391,71.682,5.849 S-5.678,75.539,57.837,81.89c63.516,6.352,59.751-37.084,83.41-27.162s5.512,57.105-38.042,58.92 c-43.554,1.815-19.887,59.658,57.202,10.321s-17.278-94.706,36.257-83.817s-31.758,93.459,2.722,87.107s62.608-50.812,50.812-76.219 c-11.796-25.406,23.814-33.813,27.786-2.389 ",
    "M280,90.506c-20.021-7.713-40.962-23.138-74.952,0 s-53.045,22.23-68.47-3.176s-10.888-51.72-42.646-19.962S66.71,108.2,21.342,100.034 ",
    "M24.069,52.539c7.259-9.074,45.368-17.24,51.72,11.796 C82.14,93.37,94.844,165.96,103.01,130.572S95.751-1.903,112.991,19.874s-9.074,119.772,7.259,110.699 c16.333-9.074,6.352-78.941,19.962-60.793c13.61,18.147,133.383,107.977,137.012,58.979S82.246,138.829,44.031,106.074 C31.328,95.185,27.698,79.76,75.789,64.335c28.721-9.212,85.292-2.722,116.143,1.815c49.447,7.272,107.977-9.981,76.219-31.758 ",
    "M256.981,22.246C234.297,24.06,60.99-1.346,64.62,34.041 s166.048-14.518,183.288,23.592c17.24,38.109-107.977,40.831-147.901,28.128c-34.03-10.828-95.732-3.668-68.96,32.665 c25.406,34.48,238.637-53.535,244.989-20.869s-24.499,58.071-93.459,42.646 ",
    "M24.547,141.236c44.461,0,171.537,8.347,162.418-28.128 c-11.796-47.183-20.869-82.57,17.24-55.349s17.694,89.36-50.812,56.257s-35.387-88.014-88.922-68.052s-45.368,79.848,0.907,79.848 s63.516-54.442,82.57-79.848c16.342-21.789,28.128-38.109,128.846-20.869 ",
    "M22.863,76.563C48.27,56.6,69.139,49.342,121.766,87.451 s72.589,2.722,67.145-20.869s28.128-65.33,60.794-22.684s32.665,75.311,23.592,87.107c-9.074,11.796-37.844-9.314-55.67-52.747 s-48.677-40.711-61.38-23.471c-12.703,17.24-0.452,83.596-59.658,79.454c-59.207-4.142-31.986-52.233-31.986-52.233 ",
    "M37.702,53.405c0,0,68.96-33.573,83.478-12.703 S108.477,58.85,71.275,96.959c-32.331,33.12,32.665,48.09,96.181-10.888c62.516-58.05,116.143-28.128,88.922,23.592 ",
    "M269.536,102.099c-21.777,20.869-62.608,63.516-68.052,29.036 c-5.444-34.48,62.979-30.85,60.071-55.803c-2.907-24.953-75.497,4.991-103.625,29.489s-145.883-0.907-67.044-29.489 S276.795,63.082,244.13,42.213S88.063-11.322,31.806,56.731 ",
    "M43.569,79.111c0,0,14.313-18.797,24.499-4.537 C86.216,99.98,98.849,109.9,109.807,90.907c13.61-23.592,44.135-37.081,58.071-13.61c17.24,29.036,34.166,55.866,62.794,22.69 c29.758-34.486,27.036-55.355,27.036-55.355 ",
    "M267.723,90.914c-8.166-21.777-27.221-54.442-47.183-16.333 s-45.567,72.589-65.883,16.333s-43.138-57.371-63.87-45.368c-34.48,19.962-57.168,74.974-57.168,74.974 ",
    "M240,84.314c-6.458-20.667-14.208-19.375-31,2.583 s-68.471,31-76.215-7.104s-23.286,51.517-49.744,26.081S61.75,49.439,61.75,49.439 ",
    "M55.342,99.126c0,0,38.812-55.889,49.679-40.364 s20.182,49.679,26.392,46.574c6.21-3.105,35.707-61.338,50.455-49.299s16.301,44.641,25.616,47.746 C226.114,109.993,246,59.058,246,59.058 ",
    "M227,73.122c-34.946-7.357-97.48-33.107-110.355,27.589 s143.462-57.017-42.303-58.856 ",
    "M232.539,59.809c-25.406-16.333-19.962,0-42.646,16.333 s-92.18,27.221-66.959,0s46.09,61.701-2.908,35.387s-65.33-53.535-38.109-68.052 ",
    "M64.469,87.437c18.147-20.869,51.72-53.535,67.145-20.869 s66.238-7.259,35.387-19.055s-66.238,87.107,17.24,61.701s42.646-58.071,42.646-58.071 ",
    "M85.124,76.056c16.903-18.311,112.685-43.665,70.428-9.86 s-44.867,57.147,10.668,36.321s48.492-41.955,48.492-41.955 ",
    "M234.611,72.859c-41.306-27.144-119.199-54.288-92.054-16.523 s155.784,44.847,63.73,62.55S82.368,78.76,117.773,72.859s49.568,47.207,68.451-3.541S61.124,88.202,61.124,88.202 ",
    "M276,83.978c-10-23-22-39-40-20s-38.917,68-100.958,20 S24,91.978,24,91.978 "
]);

const SCALE = window.devicePixelRatio || 1;
const MARGIN = 30;
const WIDTH = 300;
const HEIGHT = 160;
const MAX_RADIUS = 18;

const ANGLE_RAD_90 = 90 * Math.PI / 180;
const ANGLE_RAD_270 = 270 * Math.PI / 180;

function shuffle(array) {
    var currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    return array;
}


class HelperCanvas {
    constructor(playback) {
        this.playback = playback;
        this.path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.path.setAttribute('d', PATHS[0]);
        this.pathLength = Math.floor(this.path.getTotalLength());
        this.pathIndex = 0;
        this.hairs = [];

        this.color = "#ffffff";
        this.hslColor = {
            h: 0, s: 0, l: 100
        };
        this.element = document.getElementById('helper-canvas');
        this.canvas = document.getElementById('helper-canvas-strokes');
        this.cursor = document.getElementById('helper-cursor');
        this.canvasContext = this.canvas.getContext('2d');


        this.isRunning = false;

        this.width = WIDTH;
        this.height = HEIGHT;
        this.setSize();
        this.anim = { p: 0 };
        this.drawCount = 0;

        this.points = [];

        this.canvasPosition = { x: 0, y: 0 };

        const brushOptions = new BrushOptions({
            thickness: 2.4,
            lineRadius: 2,
            limitMultiplier: 2,
            friction: 0.17,
            hairLength: 14,
            gravity: 0,
            round: false,
            hairsOpacity: 0.8,
        });

        const baseHairLength = 1.5;

        for (var i = 0; i < 100; i++) {
            const hair = new BrushHair({
                length: 10 + Math.random() * 10,
                thickness: 1,
                color: this.hslColor,
                spacing: Math.random() * 0.8 + 0.2,
                friction: 0.7 + Math.random() * 0.18,
                radius: 0.05 + Math.random() * 0.95,
            });
            hair.move(this.canvas.width / 2, this.canvas.height / 2, true);
            hair.changeOptions(brushOptions, baseHairLength);
            this.hairs.push(hair);
        }
    }

    resize() {
        this.setSize();
        const canvasRect = this.canvas.getBoundingClientRect();
        this.canvasPosition.x = canvasRect.left * SCALE;
        this.canvasPosition.y = canvasRect.top * SCALE;
    }

    setSize() {
        this.width = Math.round(Math.min(WIDTH, (window.innerWidth - MARGIN * 2) * 0.8));
        this.height = Math.round(HEIGHT * this.width / WIDTH);

        this.canvas.width = this.width * SCALE;
        this.canvas.height = this.height * SCALE;
        this.canvas.style.width = `${this.width}px`;
        this.canvas.style.height = `${this.height}px`;
    }

    changeColor(color, atmosphereData, complementaryColor) {
        let bgColor = '#ffffff'; //atmosphereData.noteGridColor;
        this.color = color;
        if (getColorDifference(this.color, bgColor) < 80) {
            let index = 0;
            this.color = atmosphereData.instrumentColors[index];
            while (getColorDifference(this.color, bgColor) < 80 &&
                index < atmosphereData.instrumentColors.length - 1) {
                index++;
                this.color = atmosphereData.instrumentColors[index];
            }
        }

        this.element.style.color = this.color;
        const hsl = hexToHsl(this.color);
        this.hslColor.h = hsl[0];
        this.hslColor.s = hsl[1];
        this.hslColor.l = hsl[2];
        for (const hair of this.hairs) {
            hair.changeColor(this.hslColor);
        }
        this.element.style.color = this.color;
        this.element.style.backgroundColor = bgColor;
    }

    update() {
        if (!this.isRunning) {
            return;
        }

        const pointScale = Math.min(this.width / WIDTH, this.height / HEIGHT);
        const prcnt = this.anim.p * this.pathLength;
        const point = this.path.getPointAtLength(prcnt);
        this.x = point.x * SCALE * pointScale;
        this.y = point.y * SCALE * pointScale;

        gsap.set(this.cursor, { x: this.x / SCALE, y: this.y / SCALE });

        let hairLimit = 1;
        let radius = (1 - this.anim.p) * MAX_RADIUS * pointScale;
        if (this.anim.p <= 0.5) {
            hairLimit *= this.anim.p * 2;
            radius = this.anim.p * MAX_RADIUS * pointScale;
        }

        this.points.push({
            x: this.x,
            y: this.y,
            radius: radius
        });

        if (this.points.length > 2) {
            this.points.shift();
        }

        const pointCount = this.points.length;
        if (pointCount > 1) {
            const topPoints = [];
            const bottomPoints = [];
            for (let i = 1; i < pointCount; i++) {
                const theta = Math.atan2(
                    this.points[i - 1].y - this.points[i].y,
                    this.points[i - 1].x - this.points[i].x
                );

                const p1x = this.points[i].x + (Math.cos(theta + ANGLE_RAD_90) * this.points[i].radius);
                const p1y = this.points[i].y + (Math.sin(theta + ANGLE_RAD_90) * this.points[i].radius);
                const p2x = this.points[i].x + (Math.cos(theta + ANGLE_RAD_270) * this.points[i].radius);
                const p2y = this.points[i].y + (Math.sin(theta + ANGLE_RAD_270) * this.points[i].radius);

                topPoints.push({
                    x: p1x,
                    y: p1y
                });
                bottomPoints.unshift({
                    x: p2x,
                    y: p2y
                });
            }

            const ribbonPoints = topPoints.concat(bottomPoints);
            this.canvasContext.globalAlpha = 0.7;
            this.canvasContext.fillStyle = this.color;
            this.canvasContext.beginPath();
            this.canvasContext.moveTo(ribbonPoints[0].x, ribbonPoints[0].y);
            for (let j = 1; j < ribbonPoints.length; j++) {
                this.canvasContext.lineTo(ribbonPoints[j].x, ribbonPoints[j].y);
            }
            this.canvasContext.closePath();
            this.canvasContext.fill();

            /*
            this.canvasContext.strokeStyle = this.color;
            this.canvasContext.beginPath();
            this.canvasContext.arc(this.x, this.y, 6 * SCALE, 0, 2 * Math.PI);
            this.canvasContext.stroke();
            */

            this.playback.spawnParticule(
                this.x + this.canvasPosition.x,
                this.y + this.canvasPosition.y,
                this.color,
                -4
            );

            const step = TWO_PI / HAIRS_COUNT;
            this.canvasContext.globalAlpha = 0.1;
            for (let i = 0, n = HAIRS_COUNT; i < n; i++) {
                const hair = this.hairs[i];
                const theta = i * step;
                const px = Math.cos(theta + ANGLE_RAD_180) * radius * 0.8;
                const py = Math.sin(theta + ANGLE_RAD_180) * radius * 0.8;
                hair.limit = hairLimit * 100;
                hair.move(this.x + px, this.y + py);
                hair.update();
                hair.draw(this.canvasContext);
            }
        }
    }

    animPath() {
        if (!this.isRunning) {
            return;
        }

        this.anim.p = 0;
        this.points = [];
        this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
        gsap.to(this.anim, {
            duration: Math.max(MIN_ANIM_DURATION, this.pathLength / SPEED), p: 1, ease: 'sin.inOut', onComplete: () => {
                this.pathIndex++;
                if (this.pathIndex > PATHS.length - 1) {
                    this.pathIndex = 0;
                }
                this.anim.p = 0;
                this.path.setAttribute('d', PATHS[this.pathIndex]);
                this.pathLength = Math.floor(this.path.getTotalLength());
                this.animPath();
            }, callbackScope: this
        });
    }

    stopCursor() {
        gsap.killTweensOf(this.anim);
        this.isRunning = false;
    }

    show() {

        gsap.to(this.element, {
            duration: 0.5, autoAlpha: 0.5, delay: 1.1, onStart: () => {
                this.isRunning = true;
            }, onComplete: this.animPath, callbackScope: this
        });
    }

    hide() {
        gsap.killTweensOf(this.element);
        gsap.to(this.element, { duration: 0.5, autoAlpha: 0, onComplete: this.stopCursor, callbackScope: this });
    }
}
export { HelperCanvas };